import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { FinancCCService } from '../../../../../shared/services/financ-cc.service';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { FatDoctoIProjection } from '../../../../../shared/interfaces/fat-docto-i-projection';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, tap, switchMap, finalize, catchError, filter } from 'rxjs/operators';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { TransacaoService } from '../../../../../shared/services/transacao.service';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { FatDoctoI } from '../../../../../shared/interfaces/fat-docto-i';
import { Router } from '@angular/router';
import { FinancRpCl } from '../../../../../shared/interfaces/financ-rp-cl';
import { ChangeDetectorRef } from '@angular/core';
import { FinancRpService } from '../../../../../shared/services/financ-rp.service';
import { ClassificacaoGerencialService } from '../../../../../shared/services/classificacao-gerencial.service';
import { LayoutService } from '../../../../../shared/services/layout.service';


@Component({
  selector: 'app-financ-rp-classes',
  templateUrl: './financ-rp-classes.component.html',
  styleUrls: ['./financ-rp-classes.component.scss']
})
export class FinancRpClassesComponent implements OnInit {

  public financRp: FinancRp;
  classes: FinancRpCl[];
  classesForm: FormGroup;
  isEditableClasse: { [key: number]: boolean } = {};
  classificacoes: any[] = []; // ajuste conforme necessário
  lcto: any; // ajuste conforme necessário
  public searching = false;
  private classValueReplaceArmedInputs = new WeakSet<HTMLInputElement>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FinancRpClassesComponent>,
    private confirmService: AppConfirmService,
    private financRpService: FinancRpService, 
    private classeGerencialService: ClassificacaoGerencialService,
    private router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    public layout: LayoutService
  ) { }

  ngOnInit() {
    this.financRp = this.data.payload;
    this.financRpService.getClassesByFaturaIdPage(this.financRp.id, 1, 20)
      .subscribe((pageResult: PageResult<FinancRpCl>) => {
        this.classes = pageResult.content || [];
        this.classes.forEach((classe, index) => {
          this.isEditableClasse[index] = false;
        });
        this.cdr.detectChanges();
        this.buildForm();
  
        // Agora o formulário existe, pode acessar classesArray

        this.classesArray.controls.forEach((classeFormGroup, idx) => {
          classeFormGroup.get('searchClassificacao')?.valueChanges
            .pipe(
              filter((search) => !!search),
              tap(() => (this.searching = true)),
              debounceTime(300),
              switchMap((search) =>
                this.classeGerencialService
                  .getClassificacaoGPageSearch(1, 10, search)
                  .pipe(
                    finalize(() => (this.searching = false)),
                    catchError((error) => {
                      this.confirmService.confirm({
                        message: `A T E N Ç Ã O !  ERRO PESQUISANDO CLASSIFICAÇÃO ... ${error}`,
                        error: true,
                      });
                      return [];
                    })
                  )
              )
            )
            .subscribe((classificacoes: any) => {
              this.classificacoes = classificacoes.content || [];
              this.cdr.detectChanges();
            });
        });
      }, (error: HttpErrorResponse) => {
        this.confirmService.confirm({
          message: `A T E N Ç Ã O !  ERRO CARREGANDO CLASSES ... ${error.message}`,
          error: true,
        });
      });
  }

  buildForm() {
    this.classesForm = this.fb.group({
      classes: this.fb.array(this.classes.map(cl => this.fb.group({
        id: [cl.id],
        cadCadastroId: [cl.cadCadastroId],
        datalcto: [cl.datalcto],
        financClassificacaoG: [cl.financClassificacaoG, Validators.required],
        natureza: [cl.natureza, Validators.required],
        valor: [cl.valor, Validators.required],
        tipo: [cl.tipo, Validators.required],
        regimecaixa: [cl.regimecaixa, Validators.required],
        regimecompetencia: [cl.regimecompetencia, Validators.required],
        financRp: [this.financRp],
        searchClassificacao: [""],
      })))
    });
    
    this.cdr.detectChanges();
  }

  get classesArray(): FormArray {
    return this.classesForm?.get('classes') as FormArray;
  }
  
  get classesRows() {
    return this.classesArray ? [...this.classesArray.controls] : [];
  }

  

  editClasse(rowIndex: number) {
    this.isEditableClasse[rowIndex] = true;
    const classeFormGroup = this.classesArray.at(rowIndex) as FormGroup;
    const classificacaoAtual = classeFormGroup.get("financClassificacaoG")?.value;
    if (
      classificacaoAtual &&
      this.classificacoes &&
      !this.classificacoes.some(c => c.id === classificacaoAtual.id)
    ) {
      this.classificacoes.push(classificacaoAtual);
    }
    this.cdr.detectChanges();
  }

  saveClasse(rowIndex: number) {
    const classeFormGroup = this.classesArray.at(rowIndex) as FormGroup;
    if (classeFormGroup.valid) {
      this.financRpService
        .saveOrUpdateClasse(classeFormGroup.value as FinancRpCl)
        .subscribe(
          (classeSalva) => {
            // atualizar a classe salva no array
            this.classesArray.setControl(rowIndex, this.fb.group({
              id: [classeSalva.id],
              cadCadastroId: [classeSalva.cadCadastroId],
              datalcto: [classeSalva.datalcto],
              financClassificacaoG: [classeSalva.financClassificacaoG, Validators.required],
              natureza: [classeSalva.natureza, Validators.required],
              valor: [classeSalva.valor, Validators.required],
              tipo: [classeSalva.tipo, Validators.required],
              regimecaixa: [classeSalva.regimecaixa, Validators.required],
              regimecompetencia: [classeSalva.regimecompetencia, Validators.required],
              financRp: this.financRp,
            }));
            this.isEditableClasse[rowIndex] = false;
            this.cdr.detectChanges();
           
          },
          (error) => {
            this.confirmService.confirm({
              message: `A T E N Ç Ã O !  ERRO GRAVANDO CLASSE ... ${error}`,
              error: true,
            });
          }
        );
      this.isEditableClasse[rowIndex] = false;
      this.cdr.detectChanges();
    } else {
      this.confirmService.confirm({
        message: `Classe inválida. Por favor, preencha todos os campos obrigatórios.`,
        error: true,
      });
      classeFormGroup.markAllAsTouched();
    }
  }

  removeClasse(rowIndex: number) {
    this.confirmService
      .confirm({
        message: `Deseja realmente remover esta Classificação?`,
      })
      .subscribe((result) => {
        if (result) {
          this.financRpService
            .deleteClasse(
              this.financRp.id,
              this.classesArray.at(rowIndex).get("financClassificacaoG")
                ?.value?.id ?? 0
            )
            .subscribe(
              (resposne) => {
                this.confirmService.confirm({
                  message: `Classificação removida com sucesso!`,
                }); 
                //atualizar a classe removida no array
                this.classesArray.at(rowIndex).patchValue({
                  id: null,
                  cadCadastroId: null,
                  datalcto: null,
                  financClassificacaoG: null,
                  natureza: null,
                  valor: null,
                  tipo: null,
                  regimecaixa: null,
                  regimecompetencia: null,
                  financRp: null
                });
              },
              (error) => {
                this.confirmService.confirm({
                  message: `A T E N Ç Ã O !  ERRO REMOVENDO CLASSE ... ${error}`,
                  error: true,
                });
              }
            );
          this.classesArray.removeAt(rowIndex);
          delete this.isEditableClasse[rowIndex];
          this.cdr.detectChanges();
        }
      });
  }

  onSubmit() {
    if (this.classesForm.valid) {
      this.dialogRef.close(this.classesForm.value.classes);
    } else {
      this.classesForm.markAllAsTouched();
    }
  }

  submit() {
    this.confirmService.confirm({ message: `Deseja realmente Fechar ?` })
    .subscribe(res => {
      if (res) {
        this.dialogRef.close();
      }
    }); 
  }


  // addClasse() {
  //   const novaClasse: FinancRpCl = {
  //     id: undefined,
  //     cadCadastroId: undefined,
  //     datalcto: new Date(),
  //     financClassificacaoG: null,
  //     natureza: 'Debito',
  //     valor: 0,
  //     tipo: '',
  //     regimecaixa: false,
  //     regimecompetencia: false,
  //     financRp: this.financRp
  //   };
  //   this.classesArray.push(this.fb.group({
  //     id: [novaClasse.id],
  //     cadCadastroId: [novaClasse.cadCadastroId],
  //     datalcto: [novaClasse.datalcto],
  //     financClassificacaoG: [novaClasse.financClassificacaoG, Validators.required],
  //     natureza: [novaClasse.natureza, Validators.required],
  //     valor: [novaClasse.valor, Validators.required],
  //     tipo: [novaClasse.tipo, Validators.required],
  //     regimecaixa: [novaClasse.regimecaixa, Validators.required],
  //     regimecompetencia: [novaClasse.regimecompetencia, Validators.required],
  //     financRp: [this.financRp]
  //   }));
  //   this.isEditableClasse[this.classesArray.length - 1] = true;
  //   this.cdr.detectChanges();
  // }

   addClasse() {
    const novaClasse: FinancRpCl = {
      id: undefined,
      cadCadastroId: this.financRp.cadastro.id,
      datalcto: new Date(),
      financClassificacaoG: null,
      natureza: 'Debito',
      valor: 0,
      tipo: this.financRp.natureza,
      regimecaixa: false,
      regimecompetencia: false,
      financRp: this.financRp
    };
    const classeFormGroup = this.fb.group({
      id: [novaClasse.id],
      cadCadastroId: [novaClasse.cadCadastroId],
      datalcto: [novaClasse.datalcto],
      financClassificacaoG: [novaClasse.financClassificacaoG, Validators.required],
      natureza: [novaClasse.natureza, Validators.required],
      valor: [novaClasse.valor, Validators.required],
      tipo: [novaClasse.tipo, Validators.required],
      regimecaixa: [novaClasse.regimecaixa, Validators.required],
      regimecompetencia: [novaClasse.regimecompetencia, Validators.required],
      financRp: [this.financRp],
      searchClassificacao: [""],
    });
  
    // Listener para o searchClassificacao da nova linha
    classeFormGroup.get('searchClassificacao')?.valueChanges
      .pipe(
        filter((search) => !!search),
        tap(() => (this.searching = true)),
        debounceTime(300),
        switchMap((search) =>
          this.classeGerencialService
            .getClassificacaoGPageSearch(1, 10, search)
            .pipe(
              finalize(() => (this.searching = false)),
              catchError((error) => {
                this.confirmService.confirm({
                  message: `A T E N Ç Ã O !  ERRO PESQUISANDO CLASSIFICAÇÃO ... ${error}`,
                  error: true,
                });
                return [];
              })
            )
        )
      )
      .subscribe((classificacoes: any) => {
        this.classificacoes = classificacoes.content || [];
        this.cdr.detectChanges();
      });
  
    this.classesArray.push(classeFormGroup);
    this.isEditableClasse[this.classesArray.length - 1] = true;
    this.cdr.detectChanges();
  }

  get totalClasses(): number {
    return Math.abs(
      this.classesArray.controls
        .map(ctrl => {
          const valor = Number(ctrl.get("valor")?.value || 0);
          const natureza = ctrl.get("natureza")?.value;
          return (natureza === "Credito" || natureza === "C")
            ? valor
            : (natureza === "Debito" || natureza === "D")
              ? -valor
              : valor;
        })
        .reduce((acc, val) => acc + val, 0)
    );
  }


  onSelectionChangeClasse(rowIndex: number, event: any) {
    if (event && event.value !== undefined && event.value !== null) {
      this.classesArray.at(rowIndex).get("financClassificacaoG")?.setValue(event.value);
      if (event.value.natureza !== undefined && event.value.natureza !== null) {
        this.classesArray.at(rowIndex).get("natureza")?.setValue(event.value.natureza);
      }
      this.cdr.detectChanges();
    } else {
      // Se valor for null, limpa o campo
      this.classesArray.at(rowIndex).get("financClassificacaoG")?.setValue(null);
      this.cdr.detectChanges();
    }
  }

  armClassValueReplace(event: FocusEvent) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }

    if (this.layout?.isMobile) {
      this.classValueReplaceArmedInputs.add(input);
    }

    setTimeout(() => {
      input.select();
    }, 0);
  }

  applyClassValueReplaceOnFirstKey(event: KeyboardEvent, rowIndex: number) {
    if (!this.layout?.isMobile) {
      return;
    }

    const input = event.target as HTMLInputElement | null;
    if (!input || !this.classValueReplaceArmedInputs.has(input)) {
      return;
    }

    const key = event.key;
    const isPrintable = key.length === 1;
    const isDelete = key === 'Backspace' || key === 'Delete';
    if (!isPrintable && !isDelete) {
      return;
    }

    const row = this.classesArray.at(rowIndex) as FormGroup;
    row.controls['valor'].setValue('');
    this.classValueReplaceArmedInputs.delete(input);
  }

  disarmClassValueReplace(event: FocusEvent) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }
    this.classValueReplaceArmedInputs.delete(input);
  }
}
